export default "__VITE_ASSET__wrnigB66__"